
(function () {
  function base64ToBlob(b64, mime) {
    var byteChars = atob(b64);
    var len = byteChars.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) bytes[i] = byteChars.charCodeAt(i);
    return new Blob([bytes], { type: mime });
  }
  function loadChunks(urls) {
    return Promise.all(
      urls.map(function (u) {
        return fetch(u).then(function (r) { return r.text(); });
      })
    ).then(function (parts) {
      return parts.join('');
    });
  }
  var FONT_CHUNK_URLS = [
    "\/\/babycat.la\/cdn\/shop\/t\/5\/assets\/bc-font-chunk-0.txt?v=86901679515826768601788856704",
    "\/\/babycat.la\/cdn\/shop\/t\/5\/assets\/bc-font-chunk-1.txt?v=117438565324679500471788856704"
  ];
  loadChunks(FONT_CHUNK_URLS)
    .then(function (b64) {
      var blob = base64ToBlob(b64, 'font/woff2');
      var url = URL.createObjectURL(blob);
      var fontFace = new FontFace('Andika Basic', 'url(' + url + ') format("woff2")');
      return fontFace.load();
    })
    .then(function (loadedFace) { document.fonts.add(loadedFace); })
    .catch(function (err) { console.error('Babycat.LA: font load failed', err); });
})();
